import axios from 'axios';

export const instance = axios.create({
  baseURL: 'https://haifaakhalid-admin.cloud/api/',
});
